import { render, staticRenderFns } from "./error.vue?vue&type=template&id=165a0453&scoped=true&"
import script from "./error.vue?vue&type=script&lang=js&"
export * from "./error.vue?vue&type=script&lang=js&"
import style0 from "./error.vue?vue&type=style&index=0&id=165a0453&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "165a0453",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {ButtonHome: require('D:/Project/kpwebsite/PC/components/button/home.vue').default})
